import { Reducer } from "redux";

import { AddUserResponse } from "../models/api/Admin";
import { AddUserActionDispatchTypes } from "../constants/Admin";
import { PostAddUserDispatchTypes } from "../models/dispatchTypes/Admin";

const initialState: AddUserResponse = {
  loading: false,
  response: {
    providerPortalUser: {
      userId: "",
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      status: "",
      twoFactorEnabled: true,
      accessFailedCount: true,
      registrationDate: "",
      registrationSource: "",
      approver: null,
      mfaId: 0,
      mfaType: "",
      roleId: "",
      roleType: "",
      userCreated: "",
    },
    userProviderList: [],
  },
  error: null
};

const PostAddUserReducer: Reducer<
AddUserResponse,
PostAddUserDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AddUserActionDispatchTypes.POST_ADD_USER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AddUserActionDispatchTypes.POST_ADD_USER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AddUserActionDispatchTypes.POST_ADD_USER_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
   case AddUserActionDispatchTypes.POST_ADD_USER_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostAddUserReducer;
